import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Sort } from '@angular/material/sort';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { ArticleType, AttributeGroupUsage } from 'src/erp-articles/article-types/article-type.model';
import { Article } from 'src/erp-articles/catalog/catalog.model';
import { AddProjectPosition, ProjectPosition, SearchArticle, SearchArticleResult } from '../../project.model';
import { AddProjectPartDialogComponent } from '../add-project-part-dialog/add-project-part-dialog.component';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { ArticleSelectionComponent } from 'src/erp-articles/erp-common/components/article-selection/article-selection.component';
import { DialogService } from '@sdbn/appclient';

@Component({
  selector: 'app-project-position-editor-dialog',
  templateUrl: './project-position-editor-dialog.component.html',
  styleUrls: ['./project-position-editor-dialog.component.scss']
})
export class ProjectPositionEditorDialogComponent implements OnInit {

  attributeGroupsPosition = new Array();

  name: string;
  query: string;

  formGroup = new FormGroup({
    'count': new FormControl(null, [Validators.required]),
    'description': new FormControl(null, []),
    'referenceDate': new FormControl(null, [Validators.required]),
    'notBillingRelevant': new FormControl(false, [])
  });

  confirmDisabled = false;

  projectId: number;
  parentPartId: number;

  selectedArticleId: number;

  article: Article;
  articleType: ArticleType;

  count: number;
  referenceDate: Date;
  description: string;
  notBillingRelevant: boolean;

  items = new Array<SearchArticleResult>();

  position: ProjectPosition;
  originalPosition: ProjectPosition;

  constructor(
    private articleTypeService: ArticleTypeService,
    private liveAnnouncer: LiveAnnouncer,
    private dialogService: DialogService,
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AddProjectPartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {

    this.selectedArticleId = data.selectedArticleId;
    this.projectId = data.projectId;
    this.parentPartId = data.parentPartId;
    this.originalPosition = data.position;
    if (data.position != null) {
      this.position = new ProjectPosition(data.position);
    } else {
      this.position = new ProjectPosition({});
    }

    if (this.position != null) {
      this.count = this.position.amount;
      this.description = this.position.description;
      this.selectedArticleId = this.position.articleId;
      this.referenceDate = this.position.referenceDate;
      this.notBillingRelevant = this.position.notBillingRelevant;
    }

    this.formGroup.patchValue({
      referenceDate: this.position.referenceDate,
      count: this.position != null ? this.position.amount : 0,
      query: '',
      description: this.position.description,
      notBillingRelevant: this.position.notBillingRelevant
    });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this.liveAnnouncer.announce('Sorting cleared');
    }
  }

  ngOnInit(): void {

    if (this.selectedArticleId != null) {
      this.loadArticleAndInitialize();
    }

    this.formGroup.valueChanges.subscribe(formValues => {
      console.log('form values', formValues);
      this.query = formValues.query;
      this.count = formValues.count;
      this.referenceDate = formValues.referenceDate;
      this.description = formValues.description;
      this.notBillingRelevant = formValues.notBillingRelevant;
    });

    this.formGroup.statusChanges.subscribe(newStatus => {
      this.confirmDisabled = !this.formGroup.valid;
    });
    this.confirmDisabled = !this.formGroup.valid;
    this.formGroup.markAllAsTouched();
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.position.fillValuesFromValuesMap();

    if (this.originalPosition == null) {

      const addPosition = new AddProjectPosition({
        projectPartId: this.parentPartId,
        articleId: this.selectedArticleId,
        amount: this.count,
        referenceDate: this.referenceDate,
        price: this.position.price,
        costsPriceSource: this.position.costsPriceSource,
        calculationMode: this.position.calculationMode,
        values: this.position.values,
        description: this.description,
        notBillingRelevant: this.notBillingRelevant
      });

      this.http.postWithContext<number>(environment.erpProjectEndpoint + '/addProjectPosition',
        addPosition)
        .subscribe(response => {
          this.dialogRef.close();
        }, error => {
          console.log('error is', error);
        });
    }
    else {
      this.position.amount = this.count;
      this.position.description = this.description;
      this.position.referenceDate = this.referenceDate;
      this.position.articleId = this.selectedArticleId;
      this.position.notBillingRelevant = this.notBillingRelevant;

      this.http.postWithContext<number>(environment.erpProjectEndpoint + '/changeProjectPosition', this.position)
        .subscribe(response => {
          this.dialogRef.close();
        }, error => {
          console.log('error is', error);
        });
    }
  }

  searchArticle() {
    this.dialogService.openDefault(ArticleSelectionComponent, {})
                      .afterClosed().subscribe(selectedArticle => {
      this.selectedArticleId = selectedArticle.id;
      this.loadArticleAndInitialize();
    });
  }


  private loadArticleAndInitialize() {
    console.log('loadArticleAndInitialize');
    this.http.postWithContext<Article>(environment.erpArticleEndpoint + '/getArticle', {id: this.selectedArticleId}).subscribe(article => {
      this.article = new Article(article);
      this.articleType = this.articleTypeService.getById(this.article.articleTypeId).completeArticleType;
      this.attributeGroupsPosition = this.articleType?.attributeGroups.filter(group => group.usage === AttributeGroupUsage.POSITION);
    });
  }

}
